import { render, staticRenderFns } from "./b2b-jhi-footer.vue?vue&type=template&id=311cc672&scoped=true&"
import script from "./b2b-jhi-footer.component.ts?vue&type=script&lang=ts&"
export * from "./b2b-jhi-footer.component.ts?vue&type=script&lang=ts&"
import style0 from "./b2b-jhi-footer.vue?vue&type=style&index=0&id=311cc672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311cc672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\e4initra\\e4i-nitra\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('311cc672')) {
      api.createRecord('311cc672', component.options)
    } else {
      api.reload('311cc672', component.options)
    }
    module.hot.accept("./b2b-jhi-footer.vue?vue&type=template&id=311cc672&scoped=true&", function () {
      api.rerender('311cc672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/b2b-jhi-footer/b2b-jhi-footer.vue"
export default component.exports